module.exports = __webpack_public_path__ + "static/media/1.aec7d917.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/visual-electric/hero/1.png
// module id = 375
// module chunks = 0